import React from 'react';
import i18n from 'i18next';

export const FiltersContext = React.createContext();
FiltersContext.displayName = i18n.t('context.filters.filtersContextProvider');

export const FiltersProvider = FiltersContext.Provider;
